import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import getBaseUrl from "../utils/apiUrl";
import token from "../utils/tokenAuthorization";

export const getKelas = createAsyncThunk("kelas/getKelas", async (test, { rejectWithValue }) => {
    try {
        const response = await axios.get(
            getBaseUrl + '/api/setting/classes',
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                timeout: 20000
            }
        )
        return response.data

    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message)
    }
})

const kelasSlice = createSlice({
    name: 'kelas',
    initialState: {
        listKelas: [],
        currentKelas: null,
        kelasId: null,
        loadingKelas: true,
        isInitialPage: true,
        searchedKelas: [],
        search: '',
        statusResApi: '',
        messageResApi: '',
        isDisplayMessage: false,
    },
    reducers: {
        setIsInitial: (state, action) => {
            state.isInitialPage = action.payload
        },
        setKelasId: (state, action) => {
            state.kelasId = action.payload
        },
        setCurrentKelas: (state, action) => {
            state.currentKelas = action.payload
        },
        updateStateKelas: (state, action) => {
            const { name, value } = action.payload
            state[name] = value
            if (name === 'search') {
                const filteredList = state.listKelas.filter((item) =>
                    item.kelas.toLowerCase().includes(state.search.toLowerCase())
                );
                state.searchedKelas = filteredList;
            }
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(getKelas.pending, (state) => {
                state.loadingKelas = true;
                state.currentKelas = null;
            })
            .addCase(getKelas.fulfilled, (state, action) => {
                state.loadingKelas = false;
                let initialKelas = [
                    { id: 'all', kelas: 'Semua Siswa' },
                ]
                console.log(action.payload)
                // state.listKelas = [...initialKelas, ...action.payload.data];
                state.listKelas = action.payload.data;
                state.searchedKelas = action.payload.data;
            })
            .addCase(getKelas.rejected, (state, action) => {
                state.loadingKelas = false;
                state.currentKelas = null;
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            });
    }
})

export const { setKelasId, setCurrentKelas, setIsInitial, updateStateKelas } = kelasSlice.actions
export default kelasSlice.reducer;